<template>
  <div class="zcxy">
    <div class="clearfix table-tools">
      <div class="buttons">
      </div>
      <div class="search">
        <a-form layout='inline'>
          <a-form-item>
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>上课校区</span>
              </template>
              <a-select allowClear showSearch placeholder="请选择校区" mode="multiple" :maxTagCount="1" :maxTagTextLength='5' :filterOption="filterOption" @change="handleChange" style="width: 220px;">
                <a-select-option v-for="(d, index) of studios" :key="index" :value="d['studio_id']">{{ d['filter_name'] }}</a-select-option>
              </a-select>
            </a-tooltip>
          </a-form-item>
          <a-form-item>
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>时间筛选</span>
              </template>
              <a-range-picker
                :ranges="rangesData"
                :value='rangesValue'
                :disabled-date="disabledDate" :allowClear="false"
                :default-value="[moment(paramsData.start_date,'YYYY-MM-DD'),moment(paramsData.end_date,'YYYY-MM-DD')]"  style="width: 240px"
                @change="(date, dateString)=>onChange(date, dateString,1)" />
            </a-tooltip>
          </a-form-item>
          <a-form-item>
            <a-button @click="toScreen" type="primary">筛选</a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div class="dashboard bk-group">
      <statistics :count='counts' :col="3"/>
      <a-row class="mb16" :gutter="16">
          <a-col :lg="24" :xl="12">
            <teacher :loading='loading' :item ='teacherData' :start_date='paramsData.start_date' :end_date='paramsData.end_date'/>
          </a-col>
          <a-col :lg="24" :xl="12">
            <teacherSummate :loading='loadingS'  :item ='teacherSData' :start_date='paramsData.start_date' :end_date='paramsData.end_date'/>
          </a-col>
          <a-col :lg="24" :xl="12">
            <teacherCourse :loading='loadingC' :item ='teacherCData' :start_date='paramsData.start_date' :end_date='paramsData.end_date' />
          </a-col>
          <a-col :lg="24" :xl="12">
            <teacherBook :loading='loadingB'  :item ='teacherBData' :start_date='paramsData.start_date' :end_date='paramsData.end_date' />
          </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import ranges from "@/common/mixins/ranges";
import moment from 'moment'
import teacher from './teacher'
import teacherBook from './teacherBook'
import teacherCourse from './teacherCourse'
import teacherSummate from './teacherSummate'
import statistics from '../xqypb/statistics'
export default {
  name: 'lssjtj',
  components:{
    teacher,
    teacherBook,
    teacherCourse,
    teacherSummate,
    statistics
  },
  data() {
    return {
      loading:false,
      loadingB:false,
      loadingC:false,
      loadingS:false,
      teacherData:{},
      teacherBData:{},
      teacherCData:{},
      teacherSData:{},
      studios:[],
      counts:[],
      paramsData:{
        start_date:'',
        end_date:'',
        studio_id:'',
      },
    }
  },
  mixins: [ranges],
  created() {
    this.paramsData.start_date = moment().subtract('days',30).format('YYYY-MM-DD')
    this.paramsData.end_date = moment().subtract('days',0).format('YYYY-MM-DD')
    this.rangesValue = [moment(this.paramsData.start_date,'YYYY-MM-DD'),moment(this.paramsData.end_date,'YYYY-MM-DD')]
    this.getList();
    this.getStudio();
  },

  methods: {
    moment,
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getList(obj){
      this.getCount(obj)
      this.getTeacher(obj)
      this.getTeacherSummate(obj)
      this.getTeacherCourse(obj)
      this.getTeacherBook(obj)
    },
    async getTeacher(obj){
      this.loading = true
      let res = await this.$store.dispatch('analysisTeacherAction', obj)
      this.teacherData = res.data
      this.loading = false
    },
    async getTeacherSummate(obj){
      this.loadingS = true
      let res = await this.$store.dispatch('analysisTeacherSummateAction', obj)
      this.teacherSData = res.data
      this.loadingS = false
    },
    async getTeacherCourse(obj){
      this.loadingC = true
      let res = await this.$store.dispatch('analysisTeacherCourseAction', obj)
      this.teacherCData = res.data
      this.loadingC = false
    },
    async getTeacherBook(obj){
      this.loadingB = true
      let res = await this.$store.dispatch('analysisTeacherBookAction', obj)
      this.teacherBData = res.data
      this.loadingB = false
    },
    async getStudio() {
      let res = await this.$store.dispatch('searchBelongStudioAction', {})
      this.studios = res.data
    },
    async getCount(obj){
      let res = await this.$store.dispatch('analysisTeacherCountAction', obj)
      this.counts = res.data
    },
    handleChange(value){
      this.paramsData.studio_id = value;
    },
    toScreen(){
      let obj = {
        search:this.paramsData
      }
      this.getList(obj);
    }
  }
}
</script>
